// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    RESET_EMAIL_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    resetEmailResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* resetEmail({ payload }) {
    try {
        const { id, entityName, newEmail } = payload;
        let QUERY = `
            mutation resetCompanyEmail ($id: Int!, $newEmail: String!) {
                result: resetCompanyEmail (id: $id, newEmail: $newEmail) 
            }
        `;
        if (entityName === 'SubUser') {
            QUERY = `
                mutation resetSubUserEmail ($id: Int!, $newEmail: String!) {
                    result: resetSubUserEmail (id: $id, newEmail: $newEmail) 
                }
            `;
        }
        if (entityName === 'User') {
            QUERY = `
                mutation resetUserEmail ($id: Int!, $newEmail: String!) {
                    result: resetUserEmail (id: $id, newEmail: $newEmail) 
                }
            `;
        }

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: id,
                newEmail: newEmail
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(resetEmailResult({ reset: data?.result || false }))


    } catch (exc) {
        yield put(resetEmailResult({ reset: false, error: exc }))
        //ExceptionManager(exc, 'Modules/.common/.components/resetEmail/redux/saga', 'resetEmail');
    }
}

function* watchMethods() {
    yield takeEvery(RESET_EMAIL_REQUEST, resetEmail);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}